export default function getTransformFromBearing(bearing) {
  const halfPI = Math.PI * 0.5;

  let rotation = bearing - halfPI;
  let orientation = rotation > -halfPI && rotation < halfPI ? 1 : -1;

  if (orientation === -1) {
    rotation += Math.PI;
  }

  let style = {
    transform: __NATIVE__
      ? [
          { rotate: `${rotation - halfPI}rad` },
          { scaleX: orientation },
          { scaleY: 1 }
        ]
      : `rotate(${rotation - halfPI}rad) scale(${orientation}, 1)`
  };

  return style;
}
